var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 117,
    viewBox: "0 0 100 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H99.3617V115.771H0V0ZM3.68006 3.95798V111.813H95.6816V3.95798H3.68006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6818 101.79C38.6783 101.79 25.3524 97.0532 15.6403 87.7007L27.8369 72.0324C35.6291 78.7127 44.3249 82.235 53.4723 82.235C59.3448 82.235 62.5068 80.0487 62.5068 76.4049V76.162C62.5068 72.6397 59.9094 70.6963 49.1809 68.0242C32.3541 63.8945 19.367 58.7932 19.367 41.3029V41.06C19.367 25.2702 30.9989 13.8529 49.9714 13.8529C63.4103 13.8529 73.9129 17.7396 82.4957 25.1487L71.5414 41.7888C64.3137 36.323 56.4085 33.408 49.4068 33.408C44.099 33.408 41.5016 35.8372 41.5016 38.8737V39.1166C41.5016 43.0034 44.2119 44.7038 55.1663 47.3759C73.3483 51.627 84.6414 57.943 84.6414 73.8543V74.0972C84.6414 91.466 71.8802 101.79 52.6818 101.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.20189b4503308f9c166edfe29bb5d062.svg";
export { ForwardRef as ReactComponent };